import { ConvertWithRatesFn } from "lib/frontend/lib/currency";
import { calculateProposalCompaRatio } from "lib/shared/compensation/calculateProposalCompaRatio";
import { calculateUserCompaRatio } from "lib/shared/compensation/calculateUserCompaRatio";
import { ProposalWithOwnerAndRange } from "lib/shared/proposals/types";
import { Review, Company } from "prisma/cm/client";

export const calculateUserAndProposalCompaRatio = ({
  proposal,
  review,
  company,
  convert,
}: {
  proposal: ProposalWithOwnerAndRange;
  review: Review;
  company: Company;
  convert: ConvertWithRatesFn;
}) => {
  const userCompaRatio = calculateUserCompaRatio({ user: proposal.owner, company, convert });
  const proposalCompaRatio = calculateProposalCompaRatio({ proposal, review, company, convert });

  return {
    userCompaRatio,
    proposalCompaRatio,
  };
};
